import Vue from 'vue';
export const EventBus = new Vue();

// update:result => update auto proposition result list
// update:point => update charge point
// update:campaign => update campagin with naver map info
// update:ads => update ads with naver map info
